import {NodeSelection} from "prosemirror-state";

export function resolveCurrentNodeContext(nodeView) {
    if (typeof nodeView?.getPos !== "function") return null;

    let pos = null;
    try {
        pos = nodeView.getPos();
    } catch (_error) {
        return null;
    }

    if (typeof pos !== "number") return null;

    const currentNode = nodeView.view?.state?.doc?.nodeAt(pos);
    if (!currentNode || currentNode.type !== nodeView.node.type) return null;

    return {pos, currentNode};
}

export function selectCurrentNode(nodeView, {focusView = true, scrollIntoView = true} = {}) {
    const context = resolveCurrentNodeContext(nodeView);
    if (!context) return false;

    const currentSelection = nodeView.view?.state?.selection;
    if (
        currentSelection instanceof NodeSelection
        && currentSelection.from === context.pos
        && currentSelection.node?.type === context.currentNode.type
    ) {
        if (focusView) {
            nodeView.view.focus();
        }
        return false;
    }

    let tr = nodeView.view.state.tr
        .setSelection(NodeSelection.create(nodeView.view.state.doc, context.pos));

    if (scrollIntoView) {
        tr = tr.scrollIntoView();
    }

    nodeView.view.dispatch(tr);
    if (focusView) {
        nodeView.view.focus();
    }
    return true;
}

export function deleteCurrentNode(nodeView) {
    const context = resolveCurrentNodeContext(nodeView);
    if (!context) return false;

    const tr = nodeView.view.state.tr
        .delete(context.pos, context.pos + context.currentNode.nodeSize)
        .scrollIntoView();

    nodeView.view.dispatch(tr);
    nodeView.view.focus();
    return true;
}


export function focusPromptInput(promptInputRef) {
    const input = promptInputRef?.current;
    if (!input || typeof input.focus !== "function") return false;

    input.focus();
    if (typeof input.value === "string" && typeof input.setSelectionRange === "function") {
        const end = input.value.length;
        input.setSelectionRange(end, end);
    }

    return true;
}

export function blurPromptInput(promptInputRef) {
    const input = promptInputRef?.current;
    if (!input || typeof input.blur !== "function") return false;

    input.blur();
    return true;
}

